import {Injectable} from '@angular/core';
import {ResizeService} from './resize.service';
import {Observable, fromEvent} from 'rxjs';
import {SCREEN_SIZE} from '../../classes/enums';

@Injectable()
export class BrowserResizeService extends ResizeService {
  onResize(): Observable<Event> {
    return fromEvent(window, 'resize');
  }

  getMediaQuerySize(): SCREEN_SIZE {
    // Phone Only
    if (window.matchMedia('(max-width: 599px)').matches) return SCREEN_SIZE.MOBILE_ONLY;
    // Big Desktop and up
    else if (window.matchMedia('(min-width: 1800px)').matches) return SCREEN_SIZE.BIG_DESKTOP_UP;
    // Desktop and up
    else if (window.matchMedia('(min-width: 1200px)').matches) return SCREEN_SIZE.DESKTOP_UP;
    // Tablet-landscape and up
    else if (window.matchMedia('(min-width: 900px)').matches) return SCREEN_SIZE.TABLET_LANDSCAPE_UP;
    // Tablet portrait and up
    else return SCREEN_SIZE.TABLET_PORTRAIT_UP;
  }
}
